import { SECURE_STATUS, STARTING_POINT_STATUS } from 'services/legacy/frameworks/constants'

export const BULK_MARK_PROGRESS_OPTIONS = [
  STARTING_POINT_STATUS.STARTING_POINT,
  SECURE_STATUS.SECURE,
]
